export function getEmbeddedContext() {
  try {
    const params = new URLSearchParams(window.location.search)
    const userId = params.get('userID') || ''
    const pnumber = params.get('pnumber') || ''
    const psaleIsY = (params.get('psale') || '').toLowerCase() === 'y'
    const isEmbedded = !!pnumber && !psaleIsY
    return { userId, pnumber, psaleIsY, isEmbedded }
  } catch {
    return { userId: '', pnumber: '', psaleIsY: false, isEmbedded: false }
  }
}

export function isEmbeddedFlow(): boolean {
  return getEmbeddedContext().isEmbedded
}
